<p-toast />
<div class="card">
    <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="start">
            <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" (onClick)="goBack()" />
        </ng-template>
        <ng-template pTemplate="center">
            <span class="font-semibold text-xl">Customer Support View</span>
        </ng-template>
    </p-toolbar>

    <div class="flex gap-2 mb-4 align-items-center customer-search-row">
        <p-autoComplete
            class="flex-1"
            [(ngModel)]="selectedM3Customer"
            [suggestions]="customerSearchOptions"
            (completeMethod)="searchM3Customers($event)"
            (onSelect)="onM3CustomerSelect($event)"
            field="CUSTOMER"
            placeholder="Search customer by number or name (min 3 chars)"
            styleClass="w-full"
            [dropdown]="true"
            [forceSelection]="true"
        />
        <p-button
            label="Search"
            icon="pi pi-search"
            [loading]="loadingLookup"
            [disabled]="!searchQuery || searchQuery.length < 3"
            (onClick)="lookupPortalCustomer(searchQuery)"
        />
    </div>

    <div *ngIf="selectedCustomer" class="customer-banner mb-4 p-3 border-round">
        <strong>Viewing:</strong>
        {{ selectedCustomer.customerName }} ({{ selectedCustomer.customerId }}) —
        {{ selectedCustomer.email }} — Co {{ selectedCustomer.company }} / Div {{ selectedCustomer.division }}
        <p-tag
            class="ml-2"
            [value]="selectedCustomer.portalEnabled ? 'Portal active' : 'Portal disabled'"
            [severity]="selectedCustomer.portalEnabled ? 'success' : 'danger'"
        />
    </div>

    <p-tabView *ngIf="selectedCustomer">
        <p-tabPanel header="Orders">
            <p-table [value]="orders" [loading]="loadingOrders" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Order #</th>
                        <th>Status</th>
                        <th>Requested</th>
                        <th>Net</th>
                        <th>Invoice</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-order>
                    <tr class="clickable-row" (click)="openOrderDetail(order)">
                        <td>
                            <button type="button" class="link-button" (click)="openOrderDetail(order); $event.stopPropagation()">
                                {{ order.orderNumber }}
                            </button>
                        </td>
                        <td>{{ order.orderMovingStatus || order.status }}</td>
                        <td>{{ order.requestedDate | date: 'mediumDate' }}</td>
                        <td>{{ order.netAmount }}</td>
                        <td>{{ order.invoiceNumber || '—' }}</td>
                        <td>
                            <p-button
                                label="PDF"
                                icon="pi pi-file-pdf"
                                size="small"
                                [loading]="invoiceLoadingOrder === order.orderNumber"
                                (onClick)="viewInvoice(order, $event)"
                            />
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="6">No orders for this customer.</td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
        <p-tabPanel header="Disputes">
            <p-table [value]="disputes" [loading]="loadingDisputes" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Claim #</th>
                        <th>Order</th>
                        <th>Status</th>
                        <th>Type</th>
                        <th>Created</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-dispute>
                    <tr class="clickable-row" (click)="openDisputeDetail(dispute)">
                        <td>
                            <button
                                type="button"
                                class="link-button"
                                (click)="openDisputeDetail(dispute); $event.stopPropagation()"
                            >
                                {{ dispute.claimNumber }}
                            </button>
                        </td>
                        <td>{{ dispute.orderNumber }}</td>
                        <td>{{ dispute.status }}</td>
                        <td>{{ dispute.claimType }}</td>
                        <td>{{ dispute.createdAt | date: 'medium' }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5">No disputes for this customer.</td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
    </p-tabView>
</div>
